// import React from "react";

// const GSTCertificate = () => {
//     return (
//         <div className="gst-certificate-box">

//             <div className="gst-certificate-icon">
//                 <i className="fas fa-file-invoice"></i>
//             </div>

//             <div className="gst-certificate-content">
//                 <span className="gst-small-title">
//                     Business Verification
//                 </span>

//                 <h4>GST Registered Business</h4>

//                 <p>
//                     Garud Cab is a GST registered business providing
//                     reliable and professional cab services.
//                 </p>

//                 <div className="gst-details">
//                     <span>
//                         <i className="fas fa-check-circle"></i>
//                         GST Registered
//                     </span>

//                     <span>
//                         <i className="fas fa-shield-alt"></i>
//                         Verified Business
//                     </span>
//                 </div>

//                 <a
//                     href="/images/garud-cab-gst-certificate.pdf"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="gst-view-btn"
//                 >
//                     <i className="fas fa-file-pdf"></i>
//                     View GST Certificate
//                 </a>
//             </div>

//         </div>
//     );
// };

// export default GSTCertificate;




import React from "react";

const GSTCertificate = () => {
    return (
        <div className="gst-certificate-box">

            <div className="gst-certificate-icon">
                <i className="fas fa-file-invoice"></i>
            </div>

            <div className="gst-certificate-content">

                <span className="gst-small-title">
                    Business Verification
                </span>

                <h4>GST Registered Business</h4>

                <p>
                    Garud Cab is a GST registered business providing
                    reliable and professional cab services.
                </p>

                {/* GST NUMBER */}
                <div className="gst-number">
                    <span>GSTIN</span>
                    <strong>27CSTPG0271L1ZB</strong>
                </div>

                <div className="gst-details">
                    <span>
                        <i className="fas fa-check-circle"></i>
                        GST Registered
                    </span>

                    <span>
                        <i className="fas fa-shield-alt"></i>
                        Verified Business
                    </span>
                </div>

                <a
                    href="/documents/garud-cab-gst-certificate.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="gst-view-btn"
                >
                    <i className="fas fa-file-pdf"></i>
                    View GST Certificate
                </a>

            </div>

        </div>
    );
};

export default GSTCertificate;
